import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators} from '@angular/forms';
import { ErrorStateMatcher } from '@angular/material/core';
import {Router} from '@angular/router';
import {Ordered} from 'src/app/models/ordered';
import {FrontDeskService} from 'src/app/services/front-desk.service';

export class FormErrorStateMatcher implements ErrorStateMatcher {
  isErrorState (control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    const isSubmitted = form && form.submitted;
    return !!(control && control.invalid && (control.dirty || control.touched || isSubmitted));
  }
}

@Component({
  selector: 'app-front-desk-confirmation',
  templateUrl: './front-desk-confirmation.component.html',
  styleUrls: ['./front-desk-confirmation.component.scss']
})
export class FrontDeskConfirmationComponent implements OnInit {

  public currentOrderd: Ordered;
  public usd_value: number;

  public orderForm: FormGroup;
  public matcher = new FormErrorStateMatcher();
  public spinner: boolean
  
  constructor(
    public _frontDeskService: FrontDeskService,
    private router: Router,
    private _formBuilder: FormBuilder,
  ) {

    if (!this._frontDeskService.currentMember || !this._frontDeskService.currentProduct) {
      this.router.navigate([ 'front-desk' ]);
    }

    this.currentOrderd = this._frontDeskService.currentOrdered

    this.saveOrder()
    //console.log('updateMemberSituation: ' + this._frontDeskService.updateMemberSituation)
    //console.log('currentOrderd ' + JSON.stringify(this.currentOrderd))
    
    //this.usd_value = this._frontDeskService.currentOrdered.value / this._frontDeskService.dolarCotation

    this.orderForm = this._formBuilder.group({
      tid: new FormControl('', [ Validators.required ])
    });

   }

  ngOnInit() {
  }

  saveOrder(){

      //console.log("saveOrder this.currentOrderd: " + JSON.stringify(this.currentOrderd ))

      this._frontDeskService.insertOrder(this.currentOrderd)
      .then((result) => {
        this.currentOrderd.id = result.id
        //console.log("this.currentOrderd : " + this.currentOrderd.id)
      })
      .catch(() => {
        console.log("error")
      })
      .finally(() => {
        this.spinner = false
      })

  }

  updateOrder(){
    
    if(this.orderForm.valid){

      this.currentOrderd.Tid = this.orderForm.controls.tid.value
      this.currentOrderd.paymentId =  this.orderForm.controls.tid.value
      this.currentOrderd.returnCode = "00"

     // console.log("this.currentOrderd : " + JSON.stringify(this.currentOrderd ))

      this._frontDeskService.updateOrder(this.currentOrderd)
      .then(() => {
        console.log('update order success')
        this.router.navigate([ 'front-desk-orders' ]);
      })
      .catch(() => {
        console.log("update order error")
      })
      .finally(() => {
        this.spinner = false
      })

    }
     
    
  }

  goBack(){
    this.router.navigate([ 'front-desk' ]);
  }
  
}
